import { useIntl } from 'react-intl-next';

import { notionDataFormatOptionsMessages } from './notion-messages';

const NOTION_DATA_FORMAT_OPTIONS = [
	{ message: notionDataFormatOptionsMessages.mentions, value: 'mentions' },
	{ message: notionDataFormatOptionsMessages.audioEmbeddedLink, value: 'audio_embedded_link' },
	{ message: notionDataFormatOptionsMessages.attachments, value: 'attachments' },
	{ message: notionDataFormatOptionsMessages.blockEquation, value: 'block_equation' },
	{ message: notionDataFormatOptionsMessages.breadcrumb, value: 'breadcrumb' },
	{ message: notionDataFormatOptionsMessages.bulletedLists, value: 'bulleted_lists' },
	{ message: notionDataFormatOptionsMessages.button, value: 'button' },
	{ message: notionDataFormatOptionsMessages.callout, value: 'callout' },
	{ message: notionDataFormatOptionsMessages.codeBlock, value: 'code_block' },
	{ message: notionDataFormatOptionsMessages.codeMermaid, value: 'code_mermaid' },
	{ message: notionDataFormatOptionsMessages.twoColumns, value: 'two_columns' },
	{ message: notionDataFormatOptionsMessages.customizedText, value: 'customized_text' },
	{
		message: notionDataFormatOptionsMessages.databaseChildPageProperties,
		value: 'database_child_properties',
	},
	{ message: notionDataFormatOptionsMessages.dates, value: 'dates' },
	{ message: notionDataFormatOptionsMessages.dividers, value: 'dividers' },
	{ message: notionDataFormatOptionsMessages.embed, value: 'embed' },
	{ message: notionDataFormatOptionsMessages.emojis, value: 'emojis' },
	{ message: notionDataFormatOptionsMessages.headerImages, value: 'header_images' },
	{ message: notionDataFormatOptionsMessages.headings, value: 'headings' },
	{ message: notionDataFormatOptionsMessages.images, value: 'images' },
	{ message: notionDataFormatOptionsMessages.inlineEquation, value: 'inline_equation' },
	{ message: notionDataFormatOptionsMessages.linkToPage, value: 'link_to_page' },
	{ message: notionDataFormatOptionsMessages.numberedLists, value: 'numbered_lists' },
	{ message: notionDataFormatOptionsMessages.pageComments, value: 'page_comments' },
	{ message: notionDataFormatOptionsMessages.pageEmojis, value: 'page_emojis' },
	{ message: notionDataFormatOptionsMessages.quotes, value: 'quotes' },
	{ message: notionDataFormatOptionsMessages.reminder, value: 'reminder' },
	{ message: notionDataFormatOptionsMessages.staticTables, value: 'static_tables' },
	{ message: notionDataFormatOptionsMessages.syncedBlock, value: 'synced_block' },
	{ message: notionDataFormatOptionsMessages.tableCustomization, value: 'table_customization' },
	{ message: notionDataFormatOptionsMessages.tableData, value: 'table_data' },
	{ message: notionDataFormatOptionsMessages.tableOfContents, value: 'table_of_contents' },
	{ message: notionDataFormatOptionsMessages.todoList, value: 'todo_list' },
	{ message: notionDataFormatOptionsMessages.toggleHeading, value: 'toggle_heading' },
	{ message: notionDataFormatOptionsMessages.toggleList, value: 'toggle_list' },
	{ message: notionDataFormatOptionsMessages.videoEmbeddedLink, value: 'video_embedded_link' },
	{ message: notionDataFormatOptionsMessages.webBookmark, value: 'web_bookmark' },
	{ message: notionDataFormatOptionsMessages.other, value: 'other' },
];

export const useDataFormatOptions = () => {
	const { formatMessage } = useIntl();

	return NOTION_DATA_FORMAT_OPTIONS.map((option) => ({
		value: option.value,
		label: formatMessage(option.message),
	}));
};
